import { useHook } from '../../lenteHooks'

type Props = {
  isinKey: string
}

export const FundName = ({ isinKey }: Props) => {
  const tenantId = useHook('routing.tenant.useTenantParam')()
  const { data } = useHook('fetchers.unitlink.useFetchFundVersionLatest')({
    isinKey,
    tenantId,
  })
  return data?.name ?? data?.shortName
}
